import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/nexora/Navbar";
import { Hero } from "@/components/nexora/Hero";
import { TrustStrip } from "@/components/nexora/TrustStrip";
import { Ecosystem } from "@/components/nexora/Ecosystem";
import { CoreModules } from "@/components/nexora/CoreModules";
import { HowItWorks } from "@/components/nexora/HowItWorks";
import { AffiliateBars } from "@/components/nexora/AffiliateBars";
import { MatrixSystem } from "@/components/nexora/MatrixSystem";
import { MatrixLevels } from "@/components/nexora/MatrixLevels";
import { SmartContract } from "@/components/nexora/SmartContract";
import { AfgToken } from "@/components/nexora/AfgToken";
import { SalaryFund } from "@/components/nexora/SalaryFund";
import { CommunityRewards } from "@/components/nexora/CommunityRewards";
import { JoiningInfo } from "@/components/nexora/JoiningInfo";
import { GlobalNetwork } from "@/components/nexora/GlobalNetwork";
import { Roadmap } from "@/components/nexora/Roadmap";
import { Community } from "@/components/nexora/Community";
import { Faq } from "@/components/nexora/Faq";
import { FinalCTA } from "@/components/nexora/FinalCTA";
import { Footer } from "@/components/nexora/Footer";
import { AppShell } from "@/components/dashboard/AppShell";
import { DashboardPage } from "@/pages/dashboard/DashboardPage";
import { MatrixPage } from "@/pages/dashboard/MatrixPage";
import { SimplePage } from "@/pages/dashboard/SimplePage";

const HomePage = () => (
    <div className="min-h-screen bg-nx-base font-sans text-nx-text antialiased">
        <Navbar />
        <main>
            <Hero />
            <TrustStrip />
            <Ecosystem />
            <CoreModules />
            <HowItWorks />
            <AffiliateBars />
            <MatrixSystem />
            <MatrixLevels />
            <SmartContract />
            <AfgToken />
            <SalaryFund />
            <CommunityRewards />
            <JoiningInfo />
            <GlobalNetwork />
            <Roadmap />
            <Community />
            <Faq />
            <FinalCTA />
        </main>
        <Footer />
    </div>
);

export default function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/dashboard" element={<AppShell />}>
                        <Route index element={<DashboardPage />} />
                        <Route path="matrix" element={<MatrixPage />} />
                        <Route path="team" element={<SimplePage kind="team" />} />
                        <Route path="partners" element={<SimplePage kind="partners" />} />
                        <Route path="affiliate" element={<SimplePage kind="affiliate" />} />
                        <Route path="stats" element={<SimplePage kind="stats" />} />
                        <Route path="activity" element={<SimplePage kind="activity" />} />
                        <Route path="marathon" element={<SimplePage kind="marathon" />} />
                        <Route path="social" element={<SimplePage kind="social" />} />
                        <Route path="tokens" element={<SimplePage kind="tokens" />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}
